<form [formGroup]="temasForm">
  <div
    class="tema-section-drag"
    [formArrayName]="formName"
    cdkDropList
    [cdkDropListData]="obtenerFormArray(formName)?.getRawValue()"
    (cdkDropListDropped)="dragDropTema($event, obtenerFormArray(formName))"
  >
    <section
      cdkDragLockAxis="y"
      cdkDrag
      class="content-tema-depacho"
      *ngFor="
        let temaForm of obtenerFormArray(formName)?.controls;
        let i = index
      "
      [formGroupName]="i"
    >
      <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
      <div
        class="dragdrop-handle"
        cdkDragHandle
        [ngClass]="{
          'content-tema-numero-1': i % 2 === 0,
          'content-tema-numero-2': i % 2 !== 0
        }"
      >
        {{ i + 1 }}
      </div>
      <div class="content-tema-main">
        <section class="detalle-section-uno !flex">
          <mat-form-field class="nuevo-catalogo-field !w-2/3">
            <mat-label>Tema</mat-label>
            <input
              formControlName="nombreTema"
              name="nombreTema"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="1000"
              value="item.descripcionTema"
              matInput
              placeholder="Ingresa la descripción del tipo"
              required
            />

            <mat-hint align="end"
              >{{ temaForm.get("nombreTema")?.value.length }} / 1000</mat-hint
            >
            @if (temaForm.get('nombreTema')?.invalid &&
            temaForm.get('nombreTema')?.touched) {
            <mat-error>Campo obligatorio.</mat-error>
            }
          </mat-form-field>
          <mat-slide-toggle
            labelPosition="before"
            formControlName="banEsImpreso"
            name="banEsImpreso"
            class="example-margin !w-1/6"
            [color]="'primary'"
            hideIcon="true"
            [checked]="temaForm.get('banEsImpreso')?.value"
          >
            Impreso
          </mat-slide-toggle>
          <mat-form-field class="mat-form-field-combo !w-1/6">
            <mat-label>Acciones</mat-label>
            <mat-select
              [panelWidth]="'250px'"
              formControlName="accion"
              name="accion"
              (valueChange)="getAccion($event, temaForm)"
            >
              @for (accion of acciones; track accion) {
              <mat-option [value]="accion">{{ accion.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </section>
        <section class="detalle-section-entradas">
          <div
            class="detalle-section-entrada-header"
            *ngIf="temaForm.get('entradas')?.value.length > 0"
          >
            <div class="container-material"><p>Material</p></div>
            <div class="container-entregables"><p>Entregables</p></div>
            <div class="container-archivos drag"><p>Archivos Adjuntos</p></div>
          </div>

          <div
            *ngIf="temaForm.get('entradas')?.value.length > 0"
            class="detalle-section-entrada-list dragdrop-handle"
            cdkDropList
            [cdkDropListData]="temaForm.get('entradas')?.value"
            (cdkDropListDropped)="
              dropEntrada(
                $event,
                temaForm.get('entradas')?.value,
                temaForm.get('idTema')?.value,
                temaForm.get('entradas')
              )
            "
          >
            @for (entrada of temaForm.get('entradas')?.value; track entrada) {
              @if(temaForm.get('id_empresa')?.value == "otro" && entrada.nombre_empresa != false) {
                <div class="empresa_otro !pointer-events-none">
                  <label>{{ entrada.nombre_empresa }}</label>
                </div>
              }
            <div
              [ngClass]="{
                '!pointer-events-none': !showEntrada(entrada) && !entrada.nuevo
              }"
              class="detalle-section-drag-container dragdrop-handle"
              cdkDragLockAxis="y"
              cdkDrag
            >
              <div class="example-custom-placeholder" *cdkDragPlaceholder></div>

              @if (!showEntrada(entrada)&&!entrada.nuevo) {

              <div class="!flex !p-3 !pointer-events-none">
                <p
                  class="!m-0 !min-w-min"
                  *ngIf="entrada.entregables.length === 0"
                >
                  Material Confidencial
                </p>
                <div
                  class="!pointer-events-none"
                  *ngIf="entrada.entregables.length > 0"
                  matBadgeOverlap="false"
                  matBadgeColor="warn"
                  [matBadge]="entrada.entregables.length + ' Entregables'"
                  matBadgeSize="small"
                  class="detalle-titulo !min-w-min"
                >
                  Material Confidencial
                </div>
              </div>
              } @else {
              <div class="container-material">
                <div class="material">
                  <a
                    routerLink="/entrada/{{ entrada.id_categorizacion }}/{{
                      entrada.id_entrada
                    }}"
                    target="_blank"
                    class="entradaLink !underline"
                    [matTooltip]="entrada.nombreEntradaCompleto"
                    matTooltipPosition="above"
                    aria-label="nombre de la entrada"
                  >
                    {{ entrada.nombreEntrada }}
                  </a>
                  <mat-icon
                    class="!cursor-pointer"
                    (click)="eliminarEntrada(entrada, temaForm)"
                    >delete</mat-icon
                  >
                </div>
              </div>
              <div
                class="container-entregables drag"
                cdkDropList
                [cdkDropListData]="entrada.entregables"
                (cdkDropListDropped)="
                  dropDragEntregables(
                    $event,
                    entrada.entregables,
                    temaForm.get('idTema')?.value,
                    entrada.id_entrada,
                    temaForm.get('entradas')
                  )
                "
              >
                @for (entregable of entrada.entregables; track entregable) {
                <div
                  class="entregable dragdrop-handle"
                  cdkDragLockAxis="y"
                  cdkDrag
                >
                  <div
                    class="custom-placeholder-entregables"
                    *cdkDragPlaceholder
                  ></div>
                  <div
                    class="estatus-container flex gap-1 justify-between items-center"
                  >
                    <a
                      class="entradaLink !underline"
                      href="{{ entregable.urlEntregable }}"
                      target="_blank"
                      *ngIf="entregable.nombreEntregable.trim() !== ''"
                      [matTooltip]="entregable.nombreEntregable"
                      aria-label="Button show nombre Entregable"
                      matTooltipClass="tooltip-full-width"
                      matTooltipPosition="above"
                    >
                      {{
                        entregable.nombreEntregable.trim() !== ""
                          ? entregable.nombreEntregable.length > 22
                            ? entregable.nombreEntregable.substring(0, 22) +
                              "..."
                            : entregable.nombreEntregable
                          : "Adjuntar Archivo"
                      }}
                    </a>
                    <a
                      href="javascript:void(0)"
                      (click)="descargarEntregable(entrada, entregable)"
                      *ngIf="entregable.nombreEntregable.trim() == ''"
                      class="entradaLink !underline"
                    >
                      Adjuntar Archivo
                    </a>
                    <div
                      [ngClass]="{
                        'red-bullet':
                          entregable.id_edo_entregable == 1 ||
                          entregable.id_edo_entregable == 2 ||
                          entregable.id_edo_entregable == 3,
                        'green-bullet': entregable.id_edo_entregable == 4
                      }"
                    ></div>
                  </div>
                </div>
                }
              </div>
              <div class="container-archivos !cursor-none">
                @for (archivo of entrada.archivos; track archivo) {
                <div class="archivo">
                  <div class="archivo-actions !cursor-pointer">
                    <a
                      (click)="verArchivo(archivo)"
                      class="!underline !cursor-pointer"
                      [matTooltip]="archivo.nombre_archivo"
                      matTooltipPosition="above"
                      aria-label="nombre del archivo"
                      matTooltipClass="tooltip-full-width"
                    >
                      {{
                        archivo.nombre_archivo.trim() !== ""
                          ? archivo.nombre_archivo.length > 18
                            ? archivo.nombre_archivo.substring(0, 18) + "..."
                            : archivo.nombre_archivo
                          : ""
                      }}
                    </a>

                    <div class="archivo-actions-buttons !gap-2">
                      <button
                        class="!cursor-pointer"
                        (click)="verArchivo(archivo)"
                        mat-mini-fab
                        [disabled]="archivo.nuevo"
                        color="primary"
                        aria-label="Remove file"
                        class="mr-1"
                      >
                        <mat-icon>remove_red_eye</mat-icon>
                      </button>
                      <button
                        (click)="
                          eliminarArchivo(
                            archivo,
                            temaForm.get('entradas'),
                            entrada.id_entrada
                          )
                        "
                        mat-mini-fab
                        color="warn"
                        aria-label="Delete file"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                }
              </div>

              }
            </div>
            }
          </div>
          <section class="detalle-section-tres !mt-4 !pb-0">
            <div class="autocomplete-container" style="width: 100%">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Buscar Entrada</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input
                  (input)="updateAutocomplete($event, temaForm)"
                  (focus)="onFocus($event, temaForm)"
                  (blur)="onBlur($event, temaForm)"
                  matInput
                  formControlName="entradaSelected"
                  [matAutocomplete]="auto"
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="onItemSelected($event, temaForm)"
                >
                  <mat-option
                    *ngFor="let item of getLista(listaEntradas)"
                    [value]="item"
                  >
                    <span mat-highlight>{{ item.nombreEntradaCompleto }}</span>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <span
                class="sin-resultados"
                mat-highlight
                *ngIf="
                  listaEntradas.length === 0 &&
                  temaForm.get('entradaSelected')?.value != ''
                "
              >
                No se encuentra la entrada "{{
                  temaForm.get("entradaSelected")?.value
                }}".
              </span>
            </div>
            <div>
              <mat-checkbox
                color="primary"
                (change)="updateImpresion(temaForm.value)"
                formControlName="marcarParaImpresion"
                labelPosition="before"
              >
                Marcar para impresión
              </mat-checkbox>
              {{ getImpresion(temaForm.get("id_tema")?.value, temaForm) }}
            </div>
          </section>
        </section>
      </div>
    </section>
  </div>
</form>
